import {logger} from 'tizra'
import {useBlockContext} from './useBlockContext'

const log = logger('useSuccessUrl')

export const useSuccessUrl = (): string => {
  const {successUrl} = useBlockContext()
  if (typeof successUrl !== 'string') {
    return ''
  }
  if (successUrl && !successUrl.startsWith('/')) {
    log.error(`Ignoring invalid successUrl: ${successUrl}`)
    return ''
  }
  return successUrl
}
